import { z } from 'zod';
import { AlertStatus, DeliveryStatus, EventType, NotificationChannel, Severity, } from './enums.js';
export const Alert = z.object({
    id: z.string().uuid(),
    eventId: z.string().uuid().nullable(),
    eventType: EventType,
    severity: Severity,
    status: AlertStatus,
    title: z.string(),
    body: z.string(),
    cameraId: z.string().uuid().nullable(),
    cameraName: z.string().nullable(),
    zoneId: z.string().uuid().nullable(),
    zoneName: z.string().nullable(),
    /** Stable hash used to collapse repeats of the same real-world situation. */
    dedupKey: z.string(),
    /** How many raw events have folded into this one alert. */
    occurrenceCount: z.number().int().positive(),
    firstSeenAt: z.string().datetime(),
    lastSeenAt: z.string().datetime(),
    acknowledgedAt: z.string().datetime().nullable(),
    acknowledgedBy: z.string().uuid().nullable(),
    acknowledgedByName: z.string().nullable().optional(),
    resolvedAt: z.string().datetime().nullable(),
    resolvedBy: z.string().uuid().nullable(),
    snapshotPath: z.string().nullable(),
    metadata: z.record(z.unknown()).default({}),
    createdAt: z.string().datetime(),
});
export const NotificationLog = z.object({
    id: z.string().uuid(),
    alertId: z.string().uuid(),
    userId: z.string().uuid().nullable(),
    channel: NotificationChannel,
    status: DeliveryStatus,
    recipient: z.string(),
    attempt: z.number().int().nonnegative(),
    providerMessageId: z.string().nullable(),
    errorCode: z.string().nullable(),
    errorMessage: z.string().nullable(),
    sentAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
/** One delivery job. The notifier fans an alert out into one job per recipient per channel. */
export const NotificationJob = z.object({
    v: z.literal(1),
    alertId: z.string().uuid(),
    channel: NotificationChannel,
    userId: z.string().uuid().nullable(),
    recipient: z.string(),
    severity: Severity,
    correlationId: z.string(),
});
export const NOTIFICATION_QUEUE = 'notifications';
/**
 * Default cooldown per severity, in seconds. A rule may override it.
 *
 * This is the control that stops a person standing in the storage room for
 * thirty seconds from generating one alert per frame.
 */
export const DEFAULT_COOLDOWN_SECONDS = {
    CRITICAL: 120,
    HIGH: 300,
    MEDIUM: 900,
    LOW: 3600,
};
/** Channels a severity reaches by default, before per-user preferences apply. */
export const DEFAULT_SEVERITY_CHANNELS = {
    CRITICAL: ['DASHBOARD', 'WEBPUSH', 'EMAIL', 'WHATSAPP'],
    HIGH: ['DASHBOARD', 'WEBPUSH', 'WHATSAPP'],
    MEDIUM: ['DASHBOARD', 'WEBPUSH'],
    LOW: ['DASHBOARD'],
};
export const AlertQuery = z.object({
    status: AlertStatus.optional(),
    severity: Severity.optional(),
    cameraId: z.string().uuid().optional(),
    since: z.string().datetime().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    cursor: z.string().optional(),
});
export const AcknowledgeAlertBody = z.object({
    note: z.string().max(1000).optional(),
});
//# sourceMappingURL=alerts.js.map